import request from './request';
import type {
  LotteryCampaign,
  LotteryPrize,
  LotteryRecord,
  LotteryRecordListResponse,
  QueryLotteryRecordsParams,
} from '../types/lottery';

export type LotteryCampaignPayload = Partial<
  Pick<
    LotteryCampaign,
    'name' | 'description' | 'isActive' | 'isPrimary' | 'isStandalone' | 'rules' | 'startAt' | 'endAt'
  >
>;

export const getLotteryCampaigns = async (): Promise<LotteryCampaign[]> => {
  return request({ url: '/api/lottery/campaigns', method: 'GET' });
};

export const getLotteryCampaign = async (): Promise<LotteryCampaign> => {
  return request({ url: '/api/lottery/campaign', method: 'GET' });
};

export const getLotteryCampaignById = async (id: number): Promise<LotteryCampaign> => {
  return request({ url: `/api/lottery/campaigns/${id}`, method: 'GET' });
};

export const createLotteryCampaign = async (
  data: LotteryCampaignPayload,
): Promise<LotteryCampaign> => {
  return request({ url: '/api/lottery/campaigns', method: 'POST', data });
};

export const updateLotteryCampaign = async (
  data: LotteryCampaignPayload,
  id?: number,
): Promise<LotteryCampaign> => {
  return request({
    url: id ? `/api/lottery/campaigns/${id}` : '/api/lottery/campaign',
    method: 'PATCH',
    data,
  });
};

export const getLotteryPrizes = async (campaignId?: number): Promise<LotteryPrize[]> => {
  return request({
    url: campaignId ? `/api/lottery/campaigns/${campaignId}/prizes` : '/api/lottery/prizes',
    method: 'GET',
  });
};

export const createLotteryPrize = async (
  data: Partial<LotteryPrize>,
  campaignId?: number,
): Promise<LotteryPrize> => {
  return request({
    url: campaignId ? `/api/lottery/campaigns/${campaignId}/prizes` : '/api/lottery/prizes',
    method: 'POST',
    data,
  });
};

export const updateLotteryPrize = async (
  id: number,
  data: Partial<LotteryPrize>,
): Promise<LotteryPrize> => {
  return request({ url: `/api/lottery/prizes/${id}`, method: 'PATCH', data });
};

export const deleteLotteryPrize = async (id: number): Promise<{ deleted: boolean; disabled: boolean }> => {
  return request({ url: `/api/lottery/prizes/${id}`, method: 'DELETE' });
};

export const getLotteryRecords = async (
  params: QueryLotteryRecordsParams,
): Promise<LotteryRecordListResponse> => {
  return request({ url: '/api/lottery/records', method: 'GET', params });
};

export const updateLotteryRecordStatus = async (
  id: number,
  data: Pick<LotteryRecord, 'fulfillmentStatus'> & { fulfillmentNote?: string | null },
): Promise<LotteryRecord> => {
  return request({ url: `/api/lottery/records/${id}/status`, method: 'PATCH', data });
};
